import { Product } from "../components";

export const mockedProducts: Product[] = [
  {
    id: "1",
    brand: "NIKE",
    itemName: "Mercurial Superfly 7 Elite MDS FG",
    category: "Running",
    prices: [
      {
        price: "980.00",
        currency: "€",
      },
      {
        price: "1310.00",
        currency: "€",
        variant: "original",
      },
    ],
    image: "assets/images/1.jpg",
    imageAlt: "",
  },
  {
    id: "2",
    brand: "NIKE",
    itemName: "Mercurial 7 Elite MDS FG",
    category: "Running",
    prices: [
      {
        price: "280.00",
        currency: "€",
      },
      {
        price: "310.00",
        currency: "€",
        variant: "original",
      },
    ],
    image: "assets/images/2.jpg",
    imageAlt: "",
  },
  {
    id: "3",
    brand: "ADIDAS",
    itemName: "Mercurial 5",
    category: "Running",
    prices: [
      {
        price: "40.00",
        currency: "€",
      },
      {
        price: "90.00",
        currency: "€",
        variant: "original",
      },
    ],
    image: "assets/images/3.jpg",
    imageAlt: "",
  },
  {
    id: "4",
    brand: "ADIDAS",
    itemName: "TFG lorem 1",
    category: "Running",
    prices: [
      {
        price: "290.00",
        currency: "€",
      },
      {
        price: "350.00",
        currency: "€",
        variant: "original",
      },
    ],
    image: "assets/images/4.jpg",
    imageAlt: "",
  },
  {
    id: "5",
    brand: "NIKE",
    itemName: "Lorem 5 SDW",
    category: "Running",
    prices: [
      {
        price: "210.00",
        currency: "€",
      },
      {
        price: "250.00",
        currency: "€",
        variant: "original",
      },
    ],
    image: "assets/images/5.jpg",
    imageAlt: "",
  },
];
